import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './ApplyBox.css';

class ApplyBox extends React.Component {
  constructor(props) {
    super(props);
    const { startDate, endDate } = this.props;
    this.state = {
      startDate,
      endDate,
    };
  }

  componentWillReceiveProps(props) {
    const isSameStartDate = moment(props.startDate).isSame(
      this.state.startDate
    );
    const isSameEndDate = moment(props.endDate).isSame(this.state.endDate);
    if (
      props.startDate &&
      props.endDate &&
      !(isSameEndDate && isSameStartDate)
    ) {
      this.setState({
        startDate: props.startDate,
        endDate: props.endDate,
      });
    }
  }

  render() {
    const { startDate, endDate } = this.state;
    const formattedStartDate = moment(startDate).format('D/MM/YYYY');
    const formattedEndDate = moment(endDate).format('D/MM/YYYY');
    const { fullSiteMode } = this.props;

    return (
      <div className={styles.wrapper}>
        <div className="row">
          <div className="col-md-12">
            <form className="form-inline">
              <div
                className={`form-group ${
                  !fullSiteMode ? styles['form-group'] : styles['mr-btn-5']
                }`}
              >
                <input
                  type="text"
                  className={`form-control ${
                    !fullSiteMode ? styles.input : styles['input-mobi']
                  }`}
                  value={formattedStartDate}
                />
              </div>
              <div
                className={`form-group ${
                  !fullSiteMode ? styles['form-group'] : styles['mr-btn-5']
                }`}
              >
                <input
                  type="text"
                  className={`form-control ${
                    !fullSiteMode ? styles.input : styles['input-mobi']
                  }`}
                  value={formattedEndDate}
                />
              </div>
              <div
                className={`form-group ${
                  !fullSiteMode ? styles['form-group'] : styles['mr-btn-5']
                }`}
              >
                <button
                  className={`btn btn-primary btn-block ${
                    !fullSiteMode ? styles['btn-apply'] : styles['input-mobi']
                  }`}
                  onClick={this._onClickApply}
                >
                  Apply
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  _onClickApply = e => {
    // we need this to prevent keep opening of dropdown
    // because the open state needs to be set manually (from onApply)
    e.preventDefault();
    e.stopPropagation();

    const { startDate, endDate } = this.state;

    this.props.onApply({
      startDate: moment(startDate)
        .startOf('day')
        .toISOString(),
      endDate: moment(endDate)
        .endOf('day')
        .toISOString(),
    });
  };
}

ApplyBox.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  onApply: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  null,
  mapDispatchToProps
)(ApplyBox);
